import { CommonModule, NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FocusAiService, UploadingFile } from '../../services/focus-ai.service';
import { SpinnerComponent } from '@app/shared/spinner/spinner.component';

@Component({
  selector: 'rn-focus-ai-uploading-file',
  standalone: true,
  imports: [CommonModule, NgClass, SpinnerComponent],
  templateUrl: './focus-ai-uploading-file.component.html',
  styleUrl: './focus-ai-uploading-file.component.scss',
})
export class FocusAiUploadingFileComponent implements OnInit {
  @Input({ required: true }) clientId: string;
  @Input({ required: true }) messageId: string;
  @Input({ required: true }) file: UploadingFile;

  @Output() remove = new EventEmitter<string>();

  private focusAiService = inject(FocusAiService);
  ngOnInit(): void {
    if ('url' in this.file) {
      const xhr = new XMLHttpRequest();
      xhr.withCredentials = true; // Ensure cookies are sent with the request
      xhr.open('PUT', this.file.url, true);
      const fileName = this.file.fileName;
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            console.log(`File ${fileName} uploaded successfully`);
          } else {
            console.error(`Error uploading file ${fileName}:`, xhr.statusText);
          }
        }
      };
      xhr.send(this.file.file); // Send the file directly
    }
  }

  getSize(size: string): string {
    return this.focusAiService.getFileSize(size);
  }
  removeFile(): void {
    this.remove.emit(this.file.fileName);
  }
}
